import {type Partner as RawPartner} from "@hosttools/core/config/types";

import * as logoAlertify from "../assets/logo-alertify.svg";
import * as logoCleanliSense from "../assets/logo-cleanlisense.svg";
import * as logoFreshBuzzer from "../assets/logo-freshbuzzer.svg";
import * as logoHostBuddyAI from "../assets/logo-hostbuddyai.svg";
import * as logoJervis from "../assets/logo-jervis.svg";
import * as logoPriceLabs from "../assets/logo-pricelabs.svg";
import * as logoStayFi from "../assets/logo-stayfi.svg";
import * as logoTidy from "../assets/logo-tidy.svg";
import * as logoTouchStay from "../assets/logo-touchstay.svg";
import * as logoTurnoverBnb from "../assets/logo-turnoverbnb.svg";
import * as logoWebDesignVR from "../assets/logo-webdesignvr.svg";

const partnerLogoMaps = {
    tidy: {
        label: "TIDY",
        Logo: logoTidy.ReactComponent,
        homePage: "https://tidy.com"
    },
    PriceLabs: {
        label: "PriceLabs",
        Logo: logoPriceLabs.ReactComponent,
        homePage: "https://pricelabs.co"
    },
    CleanliSense: {
        label: "CleanliSense",
        Logo: logoCleanliSense.ReactComponent,
        homePage: "https://cleanlisense.com"
    },
    TurnoverBnB: {
        label: "Turno",
        Logo: logoTurnoverBnb.ReactComponent,
        homePage: "https://turnoverbnb.com"
    },
    touchstay: {
        label: "Touch Stay",
        Logo: logoTouchStay.ReactComponent,
        homePage: "https://touchstay.com"
    },
    webdesignvr: {
        label: "WebDesignVR",
        Logo: logoWebDesignVR.ReactComponent,
        homePage: "https://webdesignvr.com"
    },
    jervis: {
        label: "Jervis",
        Logo: logoJervis.ReactComponent,
        homePage: "https://jervis.io"
    },
    FreshBuzzer: {
        label: "FreshBuzzer",
        Logo: logoFreshBuzzer.ReactComponent,
        homePage: "https://freshbuzzer.com/"
    },
    Alertify: {
        label: "Alertify",
        Logo: logoAlertify.ReactComponent,
        homePage: "https://alertify.io/"
    },
    HostBuddyAI: {
        label: "HostBuddy AI",
        Logo: logoHostBuddyAI.ReactComponent,
        homePage: "https://hostbuddy.ai/"
    },
    StayFi: {
        label: "StayFi",
        Logo: logoStayFi.ReactComponent,
        homePage: "https://stayfi.com/"
    }
} as Record<
    RawPartner["name"],
    {
        label: string;
        Logo: typeof logoTidy.ReactComponent | null;
        homePage: string;
    }
>;

class Partner {
    name: string;

    isConnected: boolean;

    label: string;

    Logo: null | typeof logoTidy.ReactComponent;

    homePage: string;

    constructor(raw: Omit<RawPartner, "apiKey">) {
        this.name = raw.name;
        this.isConnected = raw.isConnected;
        const {label, Logo, homePage} = partnerLogoMaps[raw.name] ?? {
            label: raw.name,
            homePage: ""
        };
        this.label = label ?? "";
        this.Logo = Logo ?? null;
        this.homePage = homePage ?? "";
    }
}

export default Partner;
